export const panelBodyStyle = { padding: '0 16px 16px 16px' };
